import React, { useState, useCallback, useRef } from 'react';
import { GoogleMap, Marker, Autocomplete } from '@react-google-maps/api';
import TextField from "@mui/material/TextField";
import "../Somecss.css"

const mapContainerStyle = {
  height: '400px',
  width: '100%',
};

function LocationPicker({ initialLocation, onLocationChange, onValueChange, values }) {
  const [markerPosition, setMarkerPosition] = useState(initialLocation || { lat: -3.745, lng: -38.523 });
  const [autocomplete, setAutocomplete] = useState(null);
  const mapRef = useRef(null);

  const onLoad = useCallback((map) => {
    mapRef.current = map; 
    if (initialLocation) {
      map.panTo(initialLocation);
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          map.panTo({ lat: latitude, lng: longitude });
          setMarkerPosition({ lat: latitude, lng: longitude });
        },
        () => null
      );
    }
  }, [initialLocation]);

  const onMarkerDragEnd = useCallback((e) => {
    const latitude = e.latLng.lat();
    const longitude = e.latLng.lng();
    setMarkerPosition({ latitude, longitude });
    onLocationChange({ latitude, longitude });
  }, [onLocationChange]);

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      
      
      
      
      
      
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const location = place.geometry.location;
      const latitude = location.lat();
      const longitude = location.lng();
      const newPos = { lat: latitude, lng: longitude };
      setMarkerPosition(newPos);
      onLocationChange({ latitude, longitude });
      
      if (mapRef.current) {
        mapRef.current.panTo(newPos);
      }
  
      
      const locationName = place.name || ""; 
    const address = place.formatted_address || ""; 
      let city = "";
      let state = "";
      let country = "";
  
      place.address_components.forEach((component) => {
        const types = component.types;
        
        
        
        
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }

        if (types.includes("country")) {
          country = component.long_name;
        }
      });

      onValueChange({
        locationName,
        address,
        city,
        state,
        country,
      });
    }
  };

  const onAutocompleteLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
    
  };

  return (
    <>
    <Autocomplete
        onLoad={onAutocompleteLoad}
        
        onPlaceChanged={onPlaceChanged}
      >
        <TextField
          type="text"
          placeholder="Search a location"
          variant="outlined"
          style={{
            width: '100%',
            
            
            zIndex: 1,
            padding: '10px',
          }}
        />
      </Autocomplete>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={markerPosition}
        zoom={15}
        onLoad={onLoad}
      >
        <Marker position={markerPosition} draggable onDragEnd={onMarkerDragEnd} />
      </GoogleMap> 
    </>
  );
}

export default LocationPicker;
